var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModuleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.172 2H10.828L10 2.828v58.344l.828.828h42.344l.828-.828V2.828L53.172 2zM56 47V33h8v-2h-8V17h8v-2h-8V2l-2-2H10L8 2v13H0v2h8v14H0v2h8v14H0v2h8v13l2 2h44l2-2V49h8v-2h-8z",
    fill: "#fff"
  })));
}
export default new URL("/home/runner/_work/flux-app/flux-app/frontend/src/resources/assets/module-icon.svg", import.meta.url).toString();
export { SvgModuleIcon as ReactComponent };